module.exports = __webpack_public_path__ + "img/1160_MILR_Website_HighLife_062.9cd4fe25.jpg";